import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flex-template-page',
  templateUrl: './flex-template-page.component.html',
  styleUrls: ['./flex-template-page.component.scss']
})
export class FlexTemplatePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
